import { useState } from '@wordpress/element';
import { BlockControls} from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import {VayuBlockLinkBlockControl} from '@vayu-blocks';
import { __ } from '@wordpress/i18n';
import {CopyPasteStyles} from '@vayu-blocks';

export const LottieToolbar = ({ attributes, setAttributes}) => {
    if (!attributes.lottieData) return null;

    const [rotation, setRotation] = useState(attributes.rotation);

    const rotateImage = () => {
        const newRotation = (rotation + 90);
        setRotation(newRotation);
        setAttributes({ rotation: newRotation });
    };

    return (
        <>
            <BlockControls>
                <ToolbarGroup>
                    <ToolbarButton
                        label="Rotate Image"
                        onClick={rotateImage}
                    >
                        <span
                            style={{
                                display: 'inline-block',
                                transform: `rotate(${attributes.rotation}deg)`,
                                transition: 'transform 0.3s ease-in-out'
                            }}
                            className="dashicons dashicons-image-rotate"
                        ></span>
                    </ToolbarButton>
                </ToolbarGroup>
            
            </BlockControls>

            <VayuBlockLinkBlockControl
                value={attributes.link}
                attributeKey="link"
                onChange={(key, value) => setAttributes({ [key]: value })}
            />

            <BlockControls>
                <CopyPasteStyles exclude={['lottieData','lottietype','lottieMediaId','lottieUrl']} attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/lottie'}/>
            </BlockControls>
        </>
    );
};

